//@flow

import * as React from 'react';
import * as Redux from 'redux';
import { connect } from 'react-redux';
import styled from 'styled-components';
import _ from 'lodash';
import ReactSVG from 'react-svg';
import { translate } from "react-i18next";
import { loadModelsDetails, setSelectedModelIndex } from '../../../../actions/model';
import DefaultButton from '../../../../components/DefaultButton';
import ModelIcon from './../../../../icons/3d.svg';
import NextIcon from './../../../../icons/next.svg';
import PrevIcon from './../../../../icons/prev.svg';
import { AXIOS_INSTANCE } from '../../../../types/auth';
import { SELECTED_MODEL_INDEX } from '../../../../types/model';
import type { ModelMetaData, ModelProps } from '../../../../types/model';
import Spinner from '../../../../components/Spinner';

const StyledModelWrapper = styled.div`
  position: relative;
  align-items: center;
  justify-content: center;
  display: flex;
  height: calc(100% - 3px);
  width: 100%;
  flex-direction: column;
  background-color: #242424;
  box-shadow: inset 0 0 5px rgba(0,0,0,0.75);
`;

const StyledIconWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  align-items: center;
  justify-content: center;
  background-color: #242424;
  color: #ffffff;
`;

const StyledIcon = styled.img`
  height: 30px;
  color: white;
  font-family: Open Sans, sans-serif;
  text-align: center;
  vertical-align: middle;
  user-select: none;
  display: inline-block;
  text-transform: uppercase;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
`;

const SketchfabEmbedWrapper = styled.div`
  width: 100%;
  height: 100%;
`;

class ModelWrapper extends React.Component<ModelProps, any>  {  
  constructor() {
    super();
    this.state = {
      chosenModelIndex: 0,
    }
  }

  selectModel(next: boolean): void {
    const { selectedModelIndex, setSelectedModelIndex, modelsDetails }: ModelProps = this.props;
    const { length }: Array<ModelMetaData> = modelsDetails;
    const index: number = next
      ? (selectedModelIndex === length - 1 ? 0 : selectedModelIndex + 1)
      : (selectedModelIndex === 0 ? length - 1 : selectedModelIndex - 1);
    setSelectedModelIndex(index);
  }

  componentDidMount() {
    const { chosenFlight, axiosInstance, loadModelsDetails } = this.props;
    
    //Przy uruchamianiu zawsze zaczynamy od misji
    if (chosenFlight && chosenFlight.id) {
        loadModelsDetails(axiosInstance, chosenFlight.id);
        this.setState({ chosenModelIndex: 0 });
    }
}

  componentDidUpdate(prevProps, prevState): void {
    const { loadModelsDetails, axiosInstance, chosenFlight }: ModelProps = this.props;
    if (!_.isEqual(prevProps.chosenFlight, chosenFlight)) {
      loadModelsDetails(axiosInstance, chosenFlight ? chosenFlight.id : 0);
    }
  }

  render(): React.Node {
    const { modelsDetails, selectedModelIndex, chosenFlight, t }: ModelProps = this.props;
    if (chosenFlight === null) {
      return (
        <StyledIconWrapper>
          <ReactSVG
            path={ModelIcon}
            style={{fill: '#ffffff', width: '50px', height: '50px'}}
          />
        {t('No mission selected please select')}
        </StyledIconWrapper>
      );
    }

    if (modelsDetails === null)
      return (<StyledIconWrapper><Spinner/></StyledIconWrapper>)

    if (modelsDetails.length === 0) {
      return (
        <StyledIconWrapper>
          <ReactSVG 
            path={ModelIcon}
            style={{fill: '#ffffff', width: '50px', height: '50px'}}
          />
          <p>
            {t('No models for chosen mission')}
          </p>
        </StyledIconWrapper>
      );
    }

    return (
      <StyledModelWrapper>
        <SketchfabEmbedWrapper>
          <iframe 
            title="sketchfab model 3D" width="100%" height="100%"
            src={modelsDetails[selectedModelIndex].url}
            frameBorder="0" allow="autoplay; fullscreen; vr"
            mozallowfullscreen="true" webkitallowfullscreen="true">
          </iframe>
        </SketchfabEmbedWrapper>
        <DefaultButton
          style={{ position: 'absolute', zIndex: '10', }}
          left="5px"
          top="45%"
          title={t('Previous model')}
          onClick={() => {
            this.selectModel(false);
          }}>
          <StyledIcon src={PrevIcon}/>
        </DefaultButton>
        <DefaultButton
          style={{ position: 'absolute', zIndex: '10', }}
          right="5px"
          top="45%"
          title={t('Next model')}
          onClick={() => {
            this.selectModel(true);
          }}>
          <StyledIcon src={NextIcon} />
        </DefaultButton> 
      </StyledModelWrapper>
    );
  }
}

const mapStateToProps = state => ({
  selectedModelIndex: state.model.get(SELECTED_MODEL_INDEX),
  axiosInstance: state.auth.get(AXIOS_INSTANCE),
  chosenFlight: state.flightManager.get('chosenFlight'),
  modelsDetails: state.model.get('models_details')
});

const mapDispatchToProps = dispatch => Redux.bindActionCreators({
  loadModelsDetails,
  setSelectedModelIndex,
}, dispatch);

export default translate("translations")(connect(mapStateToProps, mapDispatchToProps)(ModelWrapper));


// WEBPACK FOOTER //
// ./src/containers/content/grid/modelWrapper/ModelWrapper.jsx